import { render, staticRenderFns } from "./RedeDescredenciadaEmpty.vue?vue&type=template&id=c452b94a&scoped=true"
import script from "./RedeDescredenciadaEmpty.vue?vue&type=script&lang=js"
export * from "./RedeDescredenciadaEmpty.vue?vue&type=script&lang=js"
import style0 from "./RedeDescredenciadaEmpty.vue?vue&type=style&index=0&id=c452b94a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c452b94a",
  null
  
)

export default component.exports